import { jsx } from "react/jsx-runtime";
import { ApexSuccess } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockApexSuccess = ({
  index,
  innerBlocks = []
}) => /* @__PURE__ */ jsx(ApexSuccess, { children: generateBlockList({
  blocks: innerBlocks
}) }, index);
BlockApexSuccess.propTypes = {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  BlockApexSuccess as default
};
